import PeriodBasedInplayScoreboardImpl from './period-based-inplay-scoreboard.js';
import MojitoCore from 'mojito/core';
import { getPropTypes } from 'presentation/components/scoreboard/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * A View that displays a period-based in-play scoreboard.
 *
 * @class PeriodBasedInplayScoreboard
 * @private
 * @memberof Mojito.Presentation.Components.Scoreboard
 */

/**
 * `PeriodBasedInplayScoreboard` component properties.
 *
 * @extends Mojito.Presentation.Components.Scoreboard.default.ScoreboardPropTypes
 * @memberof Mojito.Presentation.Components.Scoreboard.PeriodBasedInplayScoreboard
 */
const propTypes = { ...getPropTypes() };

export default UIView('PeriodBasedInplayScoreboard', PeriodBasedInplayScoreboardImpl, propTypes);
